import { Reducer } from "redux";
import { QueryAction, QueryActionType } from "../actions";

export const QueryReducer: Reducer<string> = (state: string = "", action: QueryAction) => {
    switch (action.type) {
        case QueryActionType.QUERY_UPDATED:
            return action.query;
        default:
            return state;
    }
}